import { useContext } from "react";

import { TFeatures } from "@modules/features/types";

import FeatureContext from "./FeatureContext";

const useFeatureData = (): TFeatures => useContext(FeatureContext);

export default useFeatureData;
